import React from 'react';
import { IntegrationModuleListItem } from 'components/Integrations/components/IntegrationModuleListItem';
import adobeSrc from 'images/adobe_icon.png';

export const AdobeIntegrationListItem = () => (
  <IntegrationModuleListItem iconSrc={adobeSrc} content="Adobe" />
);
